import { get } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { formData, teams } from '../../../../constants/actions'
import withColorSetting from '../../../../hoc/withColorSettings'
import withUrlParams from '../../../../hoc/withUrlParams'
import {
  getAllTeamCodes,
  getCountry,
  getDefaultTeamQuestions,
  getEventTeamLimit,
  getFormId,
  getFormMessages,
  getFormSettings,
  getFormType,
  getTeamsByCode,
  getTeamsByUser,
  getTeamsInEvent,
  getUser,
  getUserId,
} from '../../../../selectors'
import TeamsComponent from './component'

const mapStateToProps = state => ({
  questions: getDefaultTeamQuestions(state),
  userId: getUserId(state),
  form: getFormId(state),
  defaultCountry: getCountry(state),
  formType: getFormType(state),
  email: getUser(state).email,
  formSettings: getFormSettings(state),
  teamsByUser: getTeamsByUser(state),
  teamsByCode: getTeamsByCode(state),
  teamCodes: getAllTeamCodes(state),
  teamsInEvent: getTeamsInEvent(state),
  registeredTeam: get(state, 'formData.team'),
  eventTeamLimit: getEventTeamLimit(state),
  teamWelcomeMessages: getFormMessages(state).teamWelcome,
})

export default withRouter(
  connect(mapStateToProps, {
    getTeamsByCode: teams.getTeamsByCode,
    getTeamsByUser: teams.getTeamsByUser,
    setTeamFormType: teams.setTeamFormType,
    getAllTeamCodes: teams.getAllTeamCodes,
    getTeamsInEvent: teams.getTeamsInEvent,
    setTeam: formData.setTeamValues,
  })(withUrlParams(withColorSetting(TeamsComponent)))
)
